import { assetPackIds } from "nemuru-components";
import { THEME_NAMES } from "./config";

export const thePowerTheme = {
  zendeskCustomerSupport: true,
  themeName: THEME_NAMES.esade,
  logoUrl: "https://cdn.nemuru.com/assets/logos/thepower-logo.svg",
  palette: {
    primary: {
      main: "#76d1a2",
      contrastText: "#1e3740",
    },
    secondary: {
      main: "#1e3740",
      contrastText: "#ffffff",
    },
    dark: {
      main: "#1e3740",
      contrastText: "#ffffff",
      accent: "#76d1a2",
      imageBackgroundOpacity: 0.85,
    },
    text: {
      title: "#0f1f26",
      primary: "#1e3740",
      secondary: "#777",
    },
    status: {
      active: "#a1e6c5",
      approved: "#76d1a2",
      analysing: "#00a0e6",
      sent: "#1c64b0",
      cancelled: "#6e6d6b",
      denied: "#f92e39",
    },
    error: {
      main: "#f92e39",
      contrastText: "#ffffff",
      light: "#fd535b",
    },
    info: {
      main: "#1c64b0",
      contrastText: "#ffffff",
      light: "#b1d3f7",
    },
    warning: {
      main: "#ffca28",
      contrastText: "#ffffff",
      light: "#ffdd80",
    },
    success: {
      main: "#76d1a2",
      contrastText: "#000",
      light: "#b2e8ce",
    },
    grey: {
      50: "#fafafa",
      100: "#f5f5f2",
      200: "#eae9e6",
      300: "#dad9d6",
      400: "#b6b5b2",
      500: "#969593",
      600: "#6e6d6b",
      700: "#5a5a57",
      800: "#3c3b39",
      900: "#1b1b19",
    },
  },
  background: "#f2f2f2",
  assetPackDefsId: assetPackIds.FILLED,
  customBorderRadius: {
    button: 0,
    paper: 0,
  },
  typography: {
    fontFamily: "Poppins, Arial, sans-serif",
  },
};
